import React, { useEffect } from "react";
import { useState } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { BiSearch } from "react-icons/bi";
import { PragmaticPlayGames } from "../../lib/data/pragmaticplay.data";
import { KingmakerGames } from "../../lib/data/KingmakerGames.data";
import { casinoTabs } from "../../lib/data/casinoTabs.data";
import { gamesData } from "../../lib/data/searchGamesData";
import { CasinoGames } from "../../lib/CasinoGames";
import { VimplayData } from "../../lib/data/vimplay.data";

const GamesSearchModal = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [filteredData, setFilteredData] = useState(null);

  const totalGames = {
    ...gamesData,
    ...PragmaticPlayGames,
    ...CasinoGames.PopularGames.slide1,
    ...CasinoGames.TvShows.slide1,
    ...CasinoGames.baccarattab.slide1,
    ...CasinoGames.baccarattab.slide2,
    ...CasinoGames.ezugiSlots.slide1,
    ...CasinoGames.ezugislots.slide1,
    ...CasinoGames.netenttab.slide1,
    ...CasinoGames.redtigertab.slide1,
    ...CasinoGames.netenttab.slide2,
    ...CasinoGames.redtigertab.slide2,
    ...CasinoGames.spribe.slide1,
    ...CasinoGames.slotsgames.slide1,
    ...CasinoGames.roulettetab.slide1,
    ...CasinoGames.roulettetab.slide2,
    ...casinoTabs.AndarBahartab,
    ...casinoTabs.BetOnNumberTab,
    ...casinoTabs.Blackjacktab,
    ...casinoTabs.TeenPattitab,
    ...casinoTabs.baccarattab,
    ...casinoTabs.indianGames,
    ...casinoTabs.popularGames,
    ...casinoTabs.roulettetab,
    ...casinoTabs.sevenLuckytab,
    ...casinoTabs.sicbotab,
    ...casinoTabs.slotsgames,
    ...casinoTabs.spribeGames,
    ...casinoTabs.thirtytwoCardtab,
    ...VimplayData,
    ...KingmakerGames?.kingmakerGames?.slide1,
  };

  useEffect(() => {
    return () => {
      setFilteredData(null);
    };
  }, []);

  const handleClose = () => {
    setFilteredData(null);
    setShow(false);
  };

  const handleSearch = (e) => {
    if (!e) {
      setFilteredData(null);
      return;
    }

    const searchTerm = e.toLowerCase();
    const filteredValue = [];
    console.log("totalGames", totalGames);
    Object.values(totalGames).forEach((game) => {
      // 1️⃣ If name exists, search in name
      if (game?.name && game.name.toLowerCase().includes(searchTerm)) {
        filteredValue.push(game);
      }
      // 2️⃣ Otherwise, search in the last part of href
      else if (game?.href) {
        const lastPart = game.href.split("/").filter(Boolean).pop(); // get last segment
        if (lastPart.toLowerCase().includes(searchTerm)) {
          filteredValue.push(game);
        }
      }
    });
    setFilteredData(filteredValue);
  };

  return (
    <div>
      <div className="searchGames" onClick={handleShow}>
        <BiSearch />
        <p>Search Games</p>
      </div>

      <div>
        <Modal show={show} onHide={handleClose} className="searchGamesModal">
          <Modal.Header closeButton>
            <Modal.Title>Search For Games</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            <InputGroup className="mb-3 search-icon">
              <Form.Control
                placeholder="Search"
                aria-label="Text input with dropdown button"
                type="search"
                onChange={(e) => handleSearch(e.target.value)}
                // style={{ color: "#000" }}
                autoFocus
              />
            </InputGroup>
            <div className="GamesShow">
              {filteredData &&
                filteredData.map((item) => {
                  console.log("item", item);
                  return (
                    <div className="displayGames">
                      <a href={item.redirectUrl || item.href}>
                        {item.img || (
                          <img
                            src={item.imgUrl || item.cover.src}
                            alt={item.name}
                          />
                        )}
                      </a>
                    </div>
                  );
                })}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default GamesSearchModal;
